import type { RouteSegment } from "../navigation/types";

export const AllowedHtmlTags = [
  "iframe",
  "img",
  "video",
  "div",
  "span",
  "p",
  "br",
];

export enum PointType {
  STEP,
  PATH,
}

export interface ScatterPoint {
  coordinates: number[];
  timeStamp: number;
  speed: number;
  isActive: boolean;
  routeId: number;
}

export interface EdgePosition {
  lat: number;
  lng: number;
  floorId: string;
  level?: number;
}

export enum FloorChangeType {
  ORIGIN = "ORIGIN",
  DESTINATION = "DESTINATION",
}

export interface FloorChange {
  lat: number;
  lng: number;
  floorId: number;
  level: number;
  relatedLevel: number;
  routeId: number;
  stepId?: number;
  type: FloorChangeType;
  inCurrentSegment: boolean;
}

export type ExtendedRouteSegment = RouteSegment & {
  isActive?: boolean;
  isLast?: boolean;
};

export enum LocationStatusTypes {
  NO_PERMISSIONS = "NO_PERMISSIONS",
  BROWSER_NO_PERMISSIONS = "BROWSER_NO_PERMISSIONS",
  BROWSER_STOPPED = "BROWSER_STOPPED",
  BROWSER_STARTING = "BROWSER_STARTING",
  BROWSER_POSITIONING = "BROWSER_POSITIONING",
  OOB = "USER_NOT_IN_BUILDING",
  OUTDOOR = "OUTDOOR",
  POSITIONING = "POSITIONING",
  STARTING = "STARTING",
  STOPPED = "STOPPED",
  UNKNOWN = "UNKNOWN",
}

/**
 * TODO: probably this enum should not exist.
 * Set of status that, when received by the viewer, will trigger it to clear the location.
 */
export enum LocationClearStatusTypes {
  NO_PERMISSIONS = LocationStatusTypes.NO_PERMISSIONS,
  STOPPED = LocationStatusTypes.STOPPED,
}

export enum PermissionErrorTypes {
  LOCATION_DENIED = "LOCATION_PERMISSION_DENIED",
  BLUETOOTH_DENIED = "BLUETOOTH_PERMISSION_DENIED",
  LOCATION_DISABLED = "LOCATION_DISABLED",
  BLUETOOTH_DISABLED = "BLUETOOTH_DISABLED",
}

export enum VisualLocationStatusTypes {
  CENTERED = "centered",
  ERROR = "error",
  LOADING = "loading",
  UNCENTERED = "uncentered",
}
